export const CHANNEL_VID_TELEGRAM = 1;
export const CHANNEL_VID_WHATSAPP = 2;
export const CHANNEL_VID_MAX = 3;
export const CHANNEL_VID_SMS = 4;
export const CHANNEL_VID_VK = 5;
export const CHANNEL_VID_PHONE = 101;
export const CHANNEL_VID_SITE = 201;

export const dictsChannelVids = [
  { value: CHANNEL_VID_TELEGRAM, label: "Телеграм" },
  { value: CHANNEL_VID_WHATSAPP, label: "WhatsApp" },
  { value: CHANNEL_VID_MAX, label: "Max" },
  { value: CHANNEL_VID_SMS, label: "SMS" },
  { value: CHANNEL_VID_VK, label: "VK" },
  { value: CHANNEL_VID_PHONE, label: "Телефон" },
  { value: CHANNEL_VID_SITE, label: "Чат на сайте" }
];

export const dictsChannelVidName = (value) =>
  dictsChannelVids.find((i) => i.value === Number(value))?.label ?? value;
